// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiUrl: 'https://djkukysweetsapp.com/kukysweets/', // new
  staticUrl: 'https://djkukysweetsapp.com/kukysweets/assets/images/logo_pic.png',
  firebase: {
    apiKey: "AIzaSyAwPtZ9C6lZzBdi0e8o6mMXKXUgX5QEz_0",
    authDomain: "kuky-sweets-fa11a.firebaseapp.com",
    databaseURL: "https://kuky-sweets-fa11a-default-rtdb.firebaseio.com",
    projectId: "kuky-sweets-fa11a",
    storageBucket: "kuky-sweets-fa11a.appspot.com",
    messagingSenderId: "923111934793",
    appId: "1:923111934793:web:50c17ae9bf365e63f9e898",
    measurementId: "G-SX835B7WGC"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
